import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Button, ButtonToolbar, ModalHeader, Input } from 'reactstrap';
import axios from 'axios';
import { useDispatch, sendFlashMessage } from "@/shared/components/flash";

const RenameSubProgramModal = ({ isOpen, setOpen, toggle, subprogram, organization, setTrigger }) => {
    const dispatch = useDispatch();
    const [newName, setNewName] = useState(subprogram?.name || '');
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState('');

    useEffect(() => {
        setNewName(subprogram?.name || '');
        setFormError('');
    }, [subprogram?.id]);

    const onClickConfirm = async () => {
        const trimmed = newName.trim();
        if (!trimmed) {
            setFormError('Name cannot be empty');
            return;
        }
        if (trimmed === subprogram.name) {
            setFormError('Name is the same as the current name');
            return;
        }
        setLoading(true);
        try {
            const response = await axios.put(
                `/organization/${subprogram.organization_id}/program/${subprogram.id}/update_name`,
                { name: trimmed }
            );
            setLoading(false);
            if (response.status === 200) {
                setOpen(false);
                dispatch(sendFlashMessage('Subprogram has been renamed', 'alert-success', 'top'));
                setTrigger(Math.floor(Date.now() / 1000));
            }
        } catch (e) {
            setLoading(false);
            dispatch(sendFlashMessage('Subprogram could not be renamed', 'alert-danger', 'top'));
        }
    };

    if (!organization || !subprogram) return null;

    return (
        <Modal className="modal-program manager-program-modal modal-md" isOpen={isOpen} toggle={toggle}>
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Rename Subprogram</h3>
                        <p className="manager-program-modal__subtitle">
                            Change the name of {subprogram.name}.
                        </p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                    </ButtonToolbar>
                </div>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body">
                <div className="form__form-group">
                    <span className="form__form-group-label">Program Name</span>
                    <div className="form__form-group-field">
                        <Input
                            type="text"
                            value={newName}
                            onChange={(e) => { setNewName(e.target.value); setFormError(''); }}
                            placeholder="Enter new program name"
                        />
                    </div>
                    {formError && <span className="form__form-group-error">{formError}</span>}
                </div>
                <div className="manager-program-modal__footer-actions">
                    <Button
                        type="button"
                        disabled={!newName.trim() || newName.trim() === subprogram.name || loading}
                        className="btn btn-primary"
                        color="#ffffff"
                        onClick={onClickConfirm}
                    >
                        Confirm Rename
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default RenameSubProgramModal;
